import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FaLock, FaSignOutAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { MainLayout } from '../../components/layout'
import { useAuthStore } from '../../store'

const Profile = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user, logout, forgotPassword, error, clearError } = useAuthStore()

  useEffect(() => {
    if (error) {
      toast.error(error)
      clearError()
    }
  }, [error, clearError])

  const handleChangePassword = async () => {
    if (!user?.email) {
      toast.error(t('profile.errors.emailNotFound'))
      return
    }

    try {
      await forgotPassword(user.email)
      toast.success(t('profile.messages.codeSent'))
      navigate('/profile/reset-password')
    } catch (err) {
      console.error('Forgot password error:', err)
      toast.error(t('profile.errors.sendCodeFailed'))
    }
  }

  const handleLogout = async () => {
    if (window.confirm(t('profile.confirmLogout'))) {
      try {
        await logout()
        toast.success(t('profile.messages.loggedOut'))
      } catch (err) {
        console.error('Logout error:', err)
      }
    }
  }

  return (
    <MainLayout title={t('profile.title')}>
      <div className="max-w-xl mx-auto px-4 sm:px-6 py-8">
				
        {user ? (
          <div className="bg-white rounded-2xl p-6 space-y-8">
            {/* User info */}
            <div className="text-center space-y-4">
              <div
                className="inline-flex items-center justify-center w-20 h-20 rounded-full"
                style={{ backgroundColor: '#cceaf6' }}
              >
                <span
                  className="text-2xl font-bold"
                  style={{ color: '#04a3d5' }}
                >
                  {user.name?.[0]?.toUpperCase()}
                </span>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  {user.name}
                </h2>
                <p className="text-gray-500">{user.email}</p>
              </div>
            </div>

            {/* Change password button */}
            <div className="border-t border-gray-200 pt-6">
              <button
                type="button"
                onClick={handleChangePassword}
                className="flex items-center justify-center gap-3 w-full px-4 py-3 font-medium rounded-xl transition-colors"
                style={{
                  backgroundColor: '#e6f5fb',
                  color: '#04a3d5',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#d0eef9')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = '#e6f5fb')
                }
              >
                <FaLock />
                {t('profile.changePassword')}
              </button>
            </div>

            {/* Logout button */}
            <div className="border-t border-gray-200 pt-6">
              <button
                onClick={handleLogout}
                className="flex items-center justify-center gap-3 w-full px-4 py-3 font-medium rounded-xl border transition-colors"
                style={{
                  color: '#e53e3e',
                  borderColor: '#f5c2c2',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#ffe5e5')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = '')
                }
              >
                <FaSignOutAlt />
                {t('profile.logout')}
              </button>
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">{t('profile.userNotFound')}</p>
          </div>
        )}
      </div>
    </MainLayout>
  )
}

export default Profile
